import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '@/SEO';
import VedaStamp from '@/components/VedaStamp';

const APARAM_RITUALS = [
  {
    title: 'பித்ரு ச்ராத்த காண்டம் & மாஸிகம்',
    sub: 'பித்ரு ச்ராத்தம், தில தர்ப்பணம், ஊனம் மற்றும் ச்ராத்த திதி கணிப்புகள்',
    veda: 'yajur',
    url: '/vaideekam/shradhakandam'
  },
  {
    title: 'ஆசௌச காண்டம் (ஜனன மரண தீட்டு கணிப்பான்)',
    sub: '10 நாள் பங்காளிகள், 3 நாள் ஸமானோதகர்கள், பக்ஷிணீ 1.5 நாள் மற்றும் கர்ப்பச்சிதைவு தீட்டு நிர்ணயம்',
    veda: 'yajur',
    url: '/vaideekam/asoucham'
  },
  {
    title: 'தஹனம் & சஞ்சயனம்',
    sub: 'இறந்த பின் முதல் நாளில் செய்யப்படும் தஹனம் மற்றும் எலும்பு சேகரிக்கும் சஞ்சயன விதி',
    veda: 'yajur',
    url: '/vaideekam/aparam'
  },
  {
    title: 'பாஷாண ஸ்தாபனம் & நித்யவிதி',
    sub: '10 நாட்கள் செய்யப்படும் கல் ஸ்தாபனம், தில தர்ப்பணம் மற்றும் பிண்ட பிரதானம்',
    veda: 'yajur',
    url: '/vaideekam/aparam'
  },
  {
    title: 'ஏகோத்ர வ்ருத்தி ச்ராத்தம் & நவச்ராத்தம்',
    sub: '10 நாட்கள் வரிசையாக செய்யப்படும் ச்ராத்தங்கள் மற்றும் பங்காளி தர்பணம்',
    veda: 'yajur',
    url: '/vaideekam/aparam'
  },
  {
    title: 'சுபஸ்வீகாரம் & ஆனந்த ஹோமம்',
    sub: '13-வது நாளில் செய்யப்படும் கிரக சுத்தி, சாந்தி ஹோமம் மற்றும் சுபஸ்வீகாரம்',
    veda: 'yajur',
    url: '/vaideekam/aparam'
  }
];

const AparamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-5xl mx-auto p-4 md:p-6 pb-24 bg-[#FAF6EE] font-sans">
      <SEO 
        title="அபரம் காண்டம் - பித்ரு கர்மாக்கள் & வேத நெறி - Ahobilam" 
        description="ஆபஸ்தம்ப யஜுர் வேத அபர காண்ட சடங்குகள், தஹனம், சஞ்சயனம், ச்ராத்தம் மற்றும் ஆசௌச விதிகள்." 
      />
      
      {/* Header Banner */}
      <div className="header-card bg-gradient-to-r from-[#1A237E] via-[#283593] to-[#1A237E] text-amber-100 p-6 md:p-8 rounded-2xl shadow-md border-b-4 border-[#D4AF37] mb-8">
        <div className="flex items-center justify-between flex-wrap gap-3 mb-4 border-b border-amber-300/30 pb-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-amber-300 block mb-1">
              பித்ரு காரிய காண்டம்
            </span>
            <h1 className="text-2xl md:text-4xl font-bold text-amber-200 tracking-wide">
              அபரம் - பித்ரு கர்மாக்கள் & வேத நெறி
            </h1>
          </div>
          <VedaStamp veda="yajur" />
        </div>

        <p className="text-amber-100/80 text-sm font-medium leading-relaxed">
          மரணம் சம்பந்தமான வைதீக காரியங்களை அபர காரியம் என்று சொல்வது மரபு. ஆபஸ்தம்ப யஜுர் வேத சாஸ்திரப்படி தஹனம் முதல் சுபஸ்வீகாரம் வரையிலான விபரங்கள்.
        </p>
      </div>

      {/* Main Content Grid */}
      <div className="space-y-4">
        <h2 className="text-xl font-bold text-[#1A237E] flex items-center space-x-2 border-b-2 border-amber-300 pb-2">
          <span>🕯️</span>
          <span>அபர காரிய பிரயோகங்கள் & வழிகாட்டிகள்</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {APARAM_RITUALS.map((item, idx) => (
            <Link
              key={idx}
              to={item.url}
              className="bg-white hover:bg-amber-50/80 p-5 rounded-2xl border-2 border-amber-200 hover:border-[#CC6600] transition-all shadow-xs hover:shadow-md flex flex-col justify-between group"
            >
              <div>
                <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
                  <VedaStamp veda={item.veda} />
                  <span className="text-xs font-bold text-[#1A237E] group-hover:underline">விவரம் ➔</span>
                </div>

                <h3 className="text-lg font-bold text-[#1A237E] group-hover:text-[#CC6600] transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-700 font-medium">
                  {item.sub}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AparamPage;
